import { redirect } from '@tanstack/react-router'
import RouterContext from '#app/router-context'
import { IStaffConfirmationStatus, staffMeQueryOptions } from '#entities/staff'

export default async function shouldBeConfirmedStaff(routerContext: RouterContext) {
  const { queryClient } = routerContext

  const currentStaff = await queryClient.fetchQuery(staffMeQueryOptions)

  if (currentStaff?.confirmationStatus !== IStaffConfirmationStatus.ProfileConfirmed) {
    throw redirect({ to: '/staff' })
  }
}
